import script from "./VitaPasswordValidator.vue?vue&type=script&setup=true&lang=ts"
export * from "./VitaPasswordValidator.vue?vue&type=script&setup=true&lang=ts"

import "./VitaPasswordValidator.vue?vue&type=style&index=0&id=4dfd5a5d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dfd5a5d"]])

export default __exports__